<template>
  <div>
    <!--    <v-row class="mb-4">
      <v-col cols="12" md="9">
        <v-tabs background-color="transparent" class="c-tabs">
          <v-tab
            v-for="tab in audienceTemplateTabs"
            :key="tab.value"
            :value="tab.value"
          >
            {{ tab.text }}
          </v-tab>
        </v-tabs>
      </v-col>
      <v-col cols="12" md="3" class="text-right">
        <v-select
          v-model="templateTypeFiltered"
          outlined
          dense
          :items="audiencesTemplatesTypes"
          placeholder="Vyberte teplotu"
          hide-details
          class="overline font-weight-bold c-input&#45;&#45;align-prepend-inner-center"
          item-text="name"
          item-value="temperature"
          clearable
        >
        </v-select>
      </v-col>
    </v-row>
    <div
      v-for="(srcTemplates, temperature) in audienceTemplateCategories"
      :key="temperature"
      class="mb-4"
    >
      <h3 class="display-1 font-weight-bold">
        {{ findAudienceTemplateTypeByTemperature(temperature).name }}
      </h3>
      <v-row>
        <v-col
          cols="12"
          sm="6"
          md="4"
          v-for="srcTemplate in srcTemplates"
          :key="srcTemplate.id"
        >
          <ui-audience-template-card
            :template="srcTemplate"
            @click="template = srcTemplate"
            :active="template && template.id === srcTemplate.id"
          />
        </v-col>
      </v-row>
    </div>-->
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="4"
        v-for="srcTemplate in Object.values(audiencesTemplates).map(
          item => item
        )"
        :key="srcTemplate.id"
      >
        <ui-audience-template-card
          :template="srcTemplate"
          @click="template = srcTemplate"
          :active="template && template.id === srcTemplate.id"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { get, sync } from "vuex-pathify"
import groupBy from "lodash/groupBy"

export default {
  name: "TemplateAudience",
  props: {
    storeNamespace: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      audienceTemplateTabs: [],
      templateTypeFiltered: null,
    }
  },
  computed: {
    ...get("audiencesTemplates", [
      "findAudienceTemplateTypeByTemperature",
      "audiencesTemplates",
      "audiencesTemplatesTypes",
    ]),
    audienceTemplateCategories() {
      const groups = groupBy(this.audiencesTemplates, "type.temperature")

      if (!this.templateTypeFiltered) {
        return groups
      }

      return {
        [this.templateTypeFiltered]: groups[this.templateTypeFiltered],
      }
    },
  },
  beforeCreate() {
    const storeNamespace = this.$options.propsData.storeNamespace

    if (!this.$options.computed) {
      this.$options.computed = {}
    }

    Object.assign(this.$options.computed, {
      ...sync(`${storeNamespace}/model@audience`, ["template"]),
    })
  },
}
</script>

<style scoped></style>
